import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import classNames from 'classnames'
import {memo, useCallback} from 'react'

import Icon from '../../../../../common/Icon/Icon'
import ValueToClickAction from '../../../../../common/ValueToClickAction/ValueToClickAction'

import {TestFilterStatus, TestStatusName} from './TestsStatusFilter.utils'

import styles from './TestsStatusFilter.css'

type Props = {
  className?: string
  status: TestFilterStatus
  all: number
  success: number
  failed: number
  muted: number
  ignored: number
  onChangeStatus: (arg0: TestFilterStatus) => unknown
}

function TestStatusFilter({
  className,
  status,
  all,
  success,
  failed,
  muted,
  ignored,
  onChangeStatus,
}: Props) {
  const renderItem = useCallback(
    (type: TestFilterStatus, countTests = 0, icon?: string) => {
      const isAllStatus = type === TestFilterStatus.ALL
      const isActive = status === type
      const child = (
        <Button
          className={classNames(styles.stateButton, {
            [styles.active]: isActive,
          })}
          title={isAllStatus ? `All tests ${countTests}` : `${countTests} ${TestStatusName[type]}`}
          active={isActive}
          data-test-build-tests={`${type}-button`}
        >
          {isAllStatus ? (
            `All ${countTests}`
          ) : (
            <>
              {icon != null && (
                <Icon className={classNames(styles.stateIcon, styles[`${type}Icon`])} name={icon} />
              )}
              <span className={styles.filterLabel}>{countTests}</span>
            </>
          )}
        </Button>
      )
      return (countTests != null && countTests > 0) || isAllStatus || isActive ? (
        <ValueToClickAction key={type} value={type} child={child} onClick={onChangeStatus} />
      ) : null
    },
    [onChangeStatus, status],
  )
  return (
    <div className={classNames(className, styles.filter)}>
      <ButtonGroup>
        {[
          renderItem(TestFilterStatus.ALL, all),
          renderItem(TestFilterStatus.PASSED, success, 'checkmark'),
          renderItem(TestFilterStatus.FAILED, failed, 'close'),
          renderItem(TestFilterStatus.MUTED, muted, 'mute'),
          renderItem(TestFilterStatus.IGNORED, ignored, 'ignored'),
        ].filter(Boolean)}
      </ButtonGroup>
    </div>
  )
}

export default memo<Props>(TestStatusFilter)
